import { useState } from 'react'

type item = {
  name: string
  value: string
}

type props = {
  id: string
  label: string
  name: string
  items: item[]
  required?: boolean
  value?: string
  autocomplete?: string
  customClass?: string
  wrapClass?: string
  onChange?: any
  labelClass?: string
}

export function SelectInput({ id, label, name, items, required, value, autocomplete = '', customClass = '', wrapClass = '', onChange, labelClass = '' }: props) {
  const [selectedValue, setSelectedValue] = useState(value || '')

  const onChangeValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const currentValue = e.target.value
    setSelectedValue(currentValue)
    if (onChange) {
      onChange(currentValue)
    }
  }
  return (
    items &&
    items.length > 0 && (
      <div>
        <div className={`input-wrap ${wrapClass}`}>
          <select
            id={id}
            name={name}
            className={`input peer ${customClass}`}
            autoComplete={autocomplete}
            value={selectedValue}
            required={required}
            onChange={onChangeValue}
          >
            {items.map((item, index) => (
              <option key={`${item}-${index}`} value={item.value}>
                {item.name}
              </option>
            ))}
          </select>
          {label && (
            <label className={`input-label ${labelClass}`} htmlFor={id}>
              {label}
            </label>
          )}
        </div>
      </div>
    )
  )
}
